import { throttle } from 'lodash';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { computed, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';

enum StatusTheme {
    free = '#2BB673',
    booked = '#B9C449',
    // booked = '#2BB673',
    occupied = '#D82D2D',
    // occupied = '#2BB673',
}

export function MixinDetailSection() {
    const DEFAULT_EL_PREFIX = 'full-map';

    let svgGroup: HTMLElement | null = null;

    const filteredPlotHouseList = computed(() => {
        return landPlotStore.CURRENT_FILTERED_LAND_PLOTS;
    });

    async function resetThemeStyle() {
        let pathGroup = svgGroup ? svgGroup.querySelectorAll('path') : null;
        if (!pathGroup) return;
        pathGroup.forEach(item => {
            item.style.stroke = '#ccc';
            item.style.strokeOpacity = '1';
            item.style.fill = '#ccc';
            item.style.pointerEvents = 'none';
            item.style.touchAction = 'none';
        });
    }

    async function setThemeStyleForFilteredPlotHouseList() {
        if (filteredPlotHouseList.value && filteredPlotHouseList.value.length) {
            filteredPlotHouseList.value.forEach(item => {

                const id = item.plot.street ? item.plot.number : null;
                if (!id) return;

                const status = item.plot.status;
                let abv = svgGroup?.querySelector(`#id_${id}`)
                const plotHouse: HTMLElement | null = svgGroup
                    ? svgGroup.querySelector(`#id_${id}`)
                    : null;

                if (!plotHouse)
                    return console.error(`plot #id_${id} not found`);

                plotHouse.style.stroke = StatusTheme[status];
                plotHouse.style.fill = StatusTheme[status];
                plotHouse.style.fillOpacity = '0.2';
                // plotHouse.style.strokeWidth = '3px';
                plotHouse.style.pointerEvents = 'unset';
                plotHouse.style.touchAction = 'unset';
            });
        } else {
            if (svgGroup) {
                const plots = svgGroup.querySelectorAll('path');
                if (plots) {
                    plots.forEach(plot => {
                        plot.style.pointerEvents = 'none';
                        plot.style.touchAction = 'none';
                        plot.style.stroke = '#ccc';
                        // plot.style.strokeWidth = '3px';
                        plot.style.fill = '#ccc';
                    });
                }
            }
        }
    }

    async function onMouseOver(e: MouseEvent) {
        if (e.target instanceof Element) {
            const mapRect = cardSettingsStore.MAP_DOM_RECT;
            const target = e.target;

            const dataRect = target.getBoundingClientRect();
            const reselutDataRect = {
                bottom: dataRect.bottom,
                height: dataRect.height,
                left: dataRect.left,
                right: dataRect.right,
                top: dataRect.top,
                topMap: mapRect.top,
                width: dataRect.width,
                x: dataRect.x,
                y: dataRect.y - mapRect.y,
            };

            const pathId = target.id ? target.id : '';
            const id = pathId.replace('id_', '');

            if (!id) return;
            if (window.innerWidth <= 1200) return;
            cardSettingsStore.SET_POSITION_CARD_HOUSE(reselutDataRect);
            await landPlotStore.CREATE_LAND_PLOT_CARD_MINI(id);
            cardSettingsStore.SET_STATUS_CARD_HOUSE_SHOW(true);
        }
    }

    async function onClick(e: MouseEvent) {
        if (e.target instanceof Element) {
            const target = e.target;
            const id = target.id ? target.id.substring(3) : '';
            if (!id) return;

            const res = await landPlotStore.CREATE_LAND_PLOT_CARD_IN_MODAL(id);
            if (res)
                cardSettingsStore.LAND_PLOT_CARD_IN_MODAL_SET_SHOW_STATUS(true);
        }
    }

    function onMouseOut(e: MouseEvent) {
        if (e.target instanceof Element) {
            cardSettingsStore.SET_STATUS_CARD_HOUSE_SHOW(false);
        }
    }

    watch(filteredPlotHouseList, () => {
        resetThemeStyle();
        setThemeStyleForFilteredPlotHouseList();
    });

    watch(
        () => landPlotStore.CURRENT_SECTION_ZONE,
        value => {
            nextTick(() => {
                svgGroup = document.querySelector(
                    `#${value || DEFAULT_EL_PREFIX}-scroll-wrapper-item`,
                );
            });
        },
    );

    onMounted(() => {
        svgGroup = document.querySelector(
            `#${landPlotStore.CURRENT_SECTION_ZONE || DEFAULT_EL_PREFIX
            }-scroll-wrapper-item`,
        );

        if (!svgGroup) return;

        svgGroup.addEventListener('mouseover', e =>
            throttle(onMouseOver, 100)(e),
        );
        svgGroup.addEventListener('mouseout', e => throttle(onMouseOut, 10)(e));

        svgGroup.addEventListener('click', onClick);

        resetThemeStyle();
        setThemeStyleForFilteredPlotHouseList();
    });

    onBeforeUnmount(() => {
        if (!svgGroup) return;
        svgGroup.removeEventListener('mouseover', e =>
            throttle(onMouseOver, 100)(e),
        );
        svgGroup.removeEventListener('mouseout', e =>
            throttle(onMouseOut, 10)(e),
        );

        svgGroup.removeEventListener('click', onClick);
    });
}
